import { render, staticRenderFns } from "./VueInfo.vue?vue&type=template&id=5d466310&scoped=true&lang=html&"
import script from "./VueInfo.vue?vue&type=script&lang=js&"
export * from "./VueInfo.vue?vue&type=script&lang=js&"
import style0 from "./VueInfo.vue?vue&type=style&index=0&id=5d466310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d466310",
  null
  
)

export default component.exports